import { CourseLessonView } from "./entities/course";

/** Aula concluída de fato (vídeo + prova da aula, se houver). */
export function isLessonDone(lesson: CourseLessonView): boolean {
  return lesson.completed;
}

/** Vídeo assistido, mas ainda falta a prova da aula (quando existir). */
export function isLessonExamPending(lesson: CourseLessonView): boolean {
  return (
    !!lesson.hasExam &&
    !lesson.completed &&
    (!!lesson.videoCompleted || !!lesson.video?.completed) &&
    !lesson.examLocked
  );
}

/** Primeira aula incompleta e desbloqueada; se todas concluídas, a última desbloqueada. */
export function resolveResumeLesson(
  lessons: CourseLessonView[]
): CourseLessonView | null {
  if (lessons.length === 0) return null;
  const next = lessons.find((l) => l.unlocked && !isLessonDone(l));
  if (next) return next;
  const lastUnlocked = [...lessons].reverse().find((l) => l.unlocked);
  return lastUnlocked ?? lessons[0];
}
